import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { Defer20220824Handler } from '@apollo/client/incremental';
import { LocalState } from '@apollo/client/local-state';
import { ErrorLink } from '@apollo/client/link/error';
import { SetContextLink } from '@apollo/client/link/context';

import typePolicies from './typePolicies';
import config from 'config';

import { ANALYTICS_EVENTS } from 'utilities/constants';

const cache = new InMemoryCache({ typePolicies });

const httpLink = new HttpLink({
  uri: config.GQL_HOST,
  credentials: 'include',
});

const authLink = new SetContextLink((previousContext) => {
  const idToken = localStorage.getItem('id_token');
  let configHeaders = config.GQL_HEADERS || {};

  // if id token is found in localstorage, add it to the headers
  if (idToken) {
    configHeaders['Authorization'] = `Bearer ${idToken}`;
  }

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...previousContext.headers,
      ...configHeaders,
    },
  };
});

const trackError = new ErrorLink(({ graphQLErrors, operation, response }) => {
  if (window.analytics) {
    window.analytics.track(ANALYTICS_EVENTS.GRAPHQL_ERROR, {
      graphQLErrors,
      operation,
      response,
    });
  }
});

const client = new ApolloClient({
  link: authLink.concat(trackError).concat(httpLink),
  cache: cache,

  /*
  Inserted by Apollo Client 3->4 migration codemod.
  If you are not using the `@client` directive in your application,
  you can safely remove this option.
  */
  localState: new LocalState({}),

  /*
  Inserted by Apollo Client 3->4 migration codemod.
  If you are not using the `@defer` directive in your application,
  you can safely remove this option.
  */
  incrementalHandler: new Defer20220824Handler(),
});

export default client;
